import { AccountCircle } from "@mui/icons-material";
import { Divider, Menu, MenuItem, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import { ReactComponent as ReactLogo } from "../logo.svg";
import { useUserContext } from "./UserContext";
import { UserProfileDialog } from "./pages/users/UserProfileDialog";
import { ENV, dayjsUtcFormat } from "./utils";
import { ThemeChooser } from "./utils/ThemeChooser";
export interface NavBarItem {
  name: string;
  location: string;
}

export interface NavBarProps {
  items: NavBarItem[];
  drawerWidth?: number;
}

export const NavBar = (props: NavBarProps) => {
  const { items, drawerWidth = 240 } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { user, isSignedIn, logout } = useUserContext();
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [time, setTime] = useState<number|null>(null);

  const selected = (item: NavBarItem) => item.location === location.pathname;

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    closeMenu();
    setProfileDialogOpen(true);
  }

  const handleLogout = () => {
    closeMenu();
    logout();
  }

  useEffect(() => {
    setProfileDialogOpen(false);
    if (ENV.IS_LOCAL) return;
    const timer = setInterval(() => {
      api.common.time().then(value => {
        setTime(value);
      });
    }, 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    }
  }, []);

  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <ReactLogo height={100} />
          <Typography align="center">System time UTC:</Typography>
          <Typography align="center">{time ? dayjsUtcFormat(time, "YYYY-MM-DD") : ""}</Typography>
          <Typography align="center">{time ? dayjsUtcFormat(time, "HH:mm:ss") : ""}</Typography>
          <Box sx={{ height: 20 }}></Box>
          <List>
            {items.map((item, index) => { 
              if (item?.name) {
                return (
                  <ListItem key={index} disablePadding>
                    <ListItemButton onClick={() => navigate(item.location)} sx={{ borderLeft: selected(item) ? "5px solid red" : "" }}>
                      <ListItemText primary={item.name} />
                    </ListItemButton>
                  </ListItem>
                )
              } else {
                return (
                  <Box sx={{ p: 1 }} key={index}>
                    <Divider></Divider>
                  </Box>
                )
              }
            })}
          </List>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box sx={{ alignSelf: "center" }}>
            <ThemeChooser />
            <IconButton onClick={handleMenu}>
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={closeMenu}
            >
              <MenuItem onClick={handleProfile}>Profile</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box sx={{ p: 2, width: "100vw", height: "100vh" }}>
          <Outlet />
        </Box>
        <UserProfileDialog open={profileDialogOpen} onClose={() => setProfileDialogOpen(false)} />
      </Box>
    </Box>
  );
};
